import { render, staticRenderFns } from "./companySet.vue?vue&type=template&id=6a1624db&"
import script from "./companySet.vue?vue&type=script&lang=js&"
export * from "./companySet.vue?vue&type=script&lang=js&"
import style0 from "./companySet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports